import { gql } from "apollo-boost";

export const PIVOT_PROFILES_DELETE = gql`
  mutation pivotProfilesDelete($profileSeqno: Int!) {
    pivotProfilesDelete(profileSeqno: $profileSeqno) {
      status
    }
  }
`;

export const PIVOT_PROFILES_ADD = gql`
  mutation pivotProfilesAdd(
    $profileName: String!
    $profileCategory: String!
    $repCols: String
    $repRows: String
    $repVals: String
    $agregatorName: String
    $rendererName: String
    $colorder: String!
    $roworder: String!
    $valueFilter: String!
    $updateSource: String
    $showTotalRows: Int
    $showTotalCols: Int
  ) {
    pivotProfilesAdd(
      pivotProfileData: {
        profileName: $profileName
        profileCategory: $profileCategory
        repCols: $repCols
        repRows: $repRows
        repVals: $repVals
        agregatorName: $agregatorName
        rendererName: $rendererName
        colorder: $colorder
        roworder: $roworder
        valueFilter: $valueFilter
        updateSource: $updateSource
        showTotalRows: $showTotalRows
        showTotalCols: $showTotalCols
      }
    ) {
      edges {
        node {
          profileSeqno
          profileName
          profileCategory
          repCols
          repRows
          repVals
          agregatorName
          rendererName
          colorder
          roworder
          valueFilter
          updateDate
          updateSource
          showTotalRows
          showTotalCols
        }
      }
    }
  }
`;
